export const VALID_PUBLIC_PRODUCTS = ['business']
export const INVALID_PUBLIC_PRODUCTS = ['personal', 'affiliate']
